import { Link } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import { useAuth } from "../hooks/useAuth.jsx";

function SuccessUpload(props) {
  const { user } = useAuth();
  const isOperator = user.user_type.includes("operator");
  const isSeller = user.user_type.includes("seller");

  const mode = props.mode;

  return (
    <>
      <Grid item xs={12}>
        {mode === "order" && <h1>Carga de Órdenes</h1>}
        {mode === "product" && <h1>Carga de Productos</h1>}
      </Grid>
      <Grid container>
        <Grid item xs={12} className="flex-center">
          <Grid container className="request-success-main-container">
            <Grid item xs={12} className="flex-center">
              <span className="confeti-icon large-icon">🎉</span>
            </Grid>
            <Grid item xs={12} className="flex-center">
              <h4 className="fw-medium">¡Carga exitosa!</h4>
            </Grid>
            <Grid item xs={12} className="flex-center">
              {mode === "order" && (
                <p>
                  Cargaste tu archivo con éxito, ahora puedes tomarte un café,
                  continuar gestionando tus envíos, o realizar una nueva carga.
                </p>
              )}
              {mode === "product" && (
                <p>
                  Cargaste tu archivo con éxito, ahora puedes tomarte un café,
                  continuar gestionando tus productos, o realizar una nueva
                  carga.
                </p>
              )}
            </Grid>
            <Grid item xs={12} sm={12} className="success-buttons-container">
              {isSeller && mode === "product" && (
                <Link to="/home/seller-inventory" className="back-login-btn">
                  <Button type="submit" variant="outlined">
                    {"Ver mis productos"}
                  </Button>
                </Link>
              )}
              {isSeller && mode === "order" && (
                <Link to="/home/deliveries-resume" className="back-login-btn">
                  <Button type="submit" variant="outlined">
                    {"Ver mis órdenes"}
                  </Button>
                </Link>
              )}
              {isOperator && !isSeller && (
                <Link to="/home/deliveries-resume" className="back-login-btn">
                  <Button type="submit" variant="outlined">
                    {"Ver mis órdenes"}
                  </Button>
                </Link>
              )}

              {mode === "order" && (
                <Link to="/home/upload-requests" className="back-login-btn">
                  <Button type="submit" variant="contained">
                    {"Nueva carga"}
                  </Button>
                </Link>
              )}
              {mode === "product" && (
                <Link
                  to="/home/seller-create-product"
                  className="back-login-btn"
                >
                  <Button type="submit" variant="contained">
                    {"Nueva carga"}
                  </Button>
                </Link>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default SuccessUpload;
